module.exports = __webpack_public_path__ + "img/杆平台.a40c8ae4.jpg";